import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { EncryptDecryptService } from "../services/encrypt-decrypt/encrypt-decrypt.service";
import { environment } from 'src/environments/environment';

@Injectable()
export class EncryptDecryptAuthInterceptor implements HttpInterceptor {

  constructor(private encryptDecryptService: EncryptDecryptService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (!req.url.includes(environment.baseUrl)) return next.handle(req);

    const request_path = req.urlWithParams.slice(environment.baseUrl.length);
    const query_string_encrypted = this.encryptDecryptService.encrypt(request_path);
    const encriptURL = `${environment.baseUrl}${query_string_encrypted}`;
    const newParams = new HttpParams();
    const cloneReq = {
        url: encriptURL,
        body: req.body,
        params: newParams,
        headers: null
    };

    if(!environment.production){
      cloneReq.headers = req.headers.set('_x-decrypted-url', req.urlWithParams)
    }
      return next.handle(req.clone(cloneReq));
  }
}
